import { Inject, Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DOCUMENT, Location, PlatformLocation } from '@angular/common';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class SEOService {
    constructor(
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly location: Location,
        private readonly platformLocation: PlatformLocation,
    ) {}

    public createLinkForCanonicalURL() {
        //have to use querySelectorAll since the various get functions in document sometimes doesnt work
        const existingLinks = this.document.querySelectorAll('[rel="canonical"]');

        let link;

        if (existingLinks.length > 0) {
            link = existingLinks[0];
        } else {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        //Using both platformLocation and location for the case where we go straight to the root url like 'http://hostname' or 'http://hostname?querystring'
        //we redirect to the start point of the quote in that case and the url becomes 'http://hostname/path' or 'http://hostname/path?querystring'
        //for whatever reason in that situation only location has the proper path while only platformLocation has the proper hostname
        //navigating to any of 'http://hostname' or 'http://hostname?querystring' or 'http://hostname/path' or 'http://hostname/path?querystring'
        //should all create the same link 'http://hostname/path' so that only that gets indexed
        //this ignores the 'port' section on localhost since we never use ports in the url on live and we dont index localhost
        link.setAttribute(
            'href',
            this.platformLocation.protocol.toString() +
                '//' +
                this.platformLocation.hostname.toString() +
                this.location.path().split('?')[0],
        );
    }
}
